<template>
  <v-card>
    <v-list two-line xl12 class="pa-0">
      <template v-for="(platform, index) in platforms">
        <v-divider :key="index" v-if="index > 0"></v-divider>

        <v-list-tile :key="platform" avatar @click="$emit('go-to-platform', platform)">
          <v-list-tile-avatar :tile="true" size="70">
            <v-img :src="`/img/platforms/${platform.toUpperCase()}.png`" :aspect-ratio="2.75"></v-img>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title class="ml-3" v-html="platform.toUpperCase()"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-card>
</template>

<script>
export default {
  props: ['platforms'],
};
</script>
